import i18n from '@/i18n';
import { useCallback } from 'react';
import {
  type ComboBoxOption,
  useComboboxOptions,
} from '@/i18n/hooks/useComboboxOptions';
import { inlineEditingEnabled } from '@/i18n/source';

const inlineTranslationKeyStore = new Map<string, ComboBoxOption>();

export const useKeyStore = () => {
  const { createUniqueValue, createUniqueOption } = useComboboxOptions();

  const addKey = useCallback(
    (key: string, namespace?: string, hasPluralization: boolean = false) => {
      if (!inlineEditingEnabled) {
        return;
      }

      namespace = namespace || i18n.options.defaultNS!.toString();
      if (typeof key !== 'string') return; // since we have jsx files

      const item = createUniqueOption(key, namespace, hasPluralization);
      inlineTranslationKeyStore.set(item.uniqueValue, item);
    },
    [createUniqueOption],
  );

  const getFromKeyStore = useCallback(
    (key: string, namespace: string) => {
      return inlineTranslationKeyStore.get(
        createUniqueValue({ key, namespace }),
      );
    },
    [createUniqueValue],
  );

  const getKeyStore = () => {
    return inlineTranslationKeyStore.values();
  };

  return {
    addKey,
    getFromKeyStore,
    getKeyStore,
  };
};
